import { render, staticRenderFns } from "./detailEventv.vue?vue&type=template&id=67abaedf&scoped=true"
import script from "./detailEventv.vue?vue&type=script&lang=js"
export * from "./detailEventv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67abaedf",
  null
  
)

export default component.exports